import React from 'react';
import { useDispatch } from 'react-redux';

import { WELCOME } from 'constants/routes';
import { WORKSPACE_WELCOME_MODAL } from 'constants/workspaceOnboarding';

import { useGetSelectedWorkspace } from 'hooks/workspace';

import BaseWelcomeModal, {
  dismissElementHandler,
} from 'components/welcome-modal';

// This modal is meant to be undismissable. Users who see this must
// click through to see the intent survey.
const WelcomeModal = () => {
  const dispatch = useDispatch();
  const selectedWorkspace = useGetSelectedWorkspace();

  const dismissHandler = async () => {
    await dismissElementHandler(
      dispatch,
      WORKSPACE_WELCOME_MODAL,
      selectedWorkspace.id
    );
    window.location.href = WELCOME;
  };

  return (
    <BaseWelcomeModal
      isOpen
      title={`Welcome to the ${selectedWorkspace?.name} Workspace`}
      subtitle="Tell us a little more about who you are and start collaborating with your team."
      buttonText="Get started"
      onButtonClick={dismissHandler}
    />
  );
};

export default WelcomeModal;
